import { CalendarDays, Clock, Hourglass, MapPin, Receipt } from "lucide-react";

import { comImposto as somarImposto, dataBR, km, reais } from "../api";

function Linha({ icone: Icone, rotulo, children }) {
  return (
    <li className="flex items-start gap-2 text-sm">
      <Icone className="w-4 h-4 mt-0.5 shrink-0 text-muted-foreground" />
      <span className="min-w-0"><span className="text-muted-foreground">{rotulo}: </span>{children}</span>
    </li>
  );
}

/** Passo 6, o resumo: o custo (semana, imposto, total), onde e quando — conferido antes de publicar. */
export default function ResumoPublicar({ a }) {
  const { form, dados, semanalCentavos } = a;
  const imposto = dados.imposto_pct || 0;
  const comImposto = somarImposto(semanalCentavos, imposto);
  const impostoSemana = comImposto - semanalCentavos;
  const fim = new Date(Date.now() + (form.continua ? 1 : form.semanas) * 7 * 86400000);
  const horario = dados.horario || {};
  const diaTodo = form.horarioModo === "dia_todo" || !horario.tem;
  const semSaldo = dados.pre_paga && dados.saldo_centavos != null && dados.saldo_centavos < comImposto;

  return (
    <section className="bg-card rounded-2xl border p-5" data-e2e="resumo-publicar">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-1.5"><Receipt className="w-3.5 h-3.5" />Resumo</p>
      <p className="text-3xl font-black tabular-nums mt-2" data-e2e="resumo-semana">{reais(comImposto)}</p>
      <p className="text-sm text-muted-foreground">por semana, já com o imposto</p>
      <dl className="mt-3 space-y-1 text-sm tabular-nums">
        <div className="flex justify-between"><dt className="text-muted-foreground">Investimento</dt><dd>{reais(semanalCentavos)}</dd></div>
        <div className="flex justify-between"><dt className="text-muted-foreground">Imposto estimado ({imposto.toLocaleString("pt-BR")}%)</dt><dd>{reais(impostoSemana)}</dd></div>
        <div className="flex justify-between border-t pt-1 font-semibold" data-e2e="resumo-total">
          <dt>{form.continua ? "Total" : `Total em ${form.semanas} ${form.semanas === 1 ? "semana" : "semanas"}`}</dt>
          <dd>{form.continua ? "renova toda semana" : reais(comImposto * form.semanas)}</dd>
        </div>
      </dl>
      <ul className="mt-4 pt-4 border-t space-y-2">
        <Linha icone={CalendarDays} rotulo="Período">
          {form.continua ? <>contínua; a primeira semana vai até <b>{dataBR(fim)}</b></> : <>de hoje até <b>{dataBR(fim)}</b></>}
        </Linha>
        <Linha icone={MapPin} rotulo="Onde"><b>{km(form.raioKm)}</b> em volta da loja</Linha>
        <Linha icone={Clock} rotulo="Quando">{diaTodo ? "o dia todo" : <>com a loja aberta ({Math.round(horario.horas_por_semana)} h por semana)</>}</Linha>
        <Linha icone={Hourglass} rotulo="Análise">a Meta analisa o anúncio em até 24 horas; avisamos no sino</Linha>
      </ul>
      {semSaldo && (
        <p className="mt-3 text-xs text-amber-600 rounded-lg bg-amber-500/10 px-3 py-2" data-e2e="resumo-saldo">
          O saldo da conta de anúncios ({reais(dados.saldo_centavos)}) não cobre a primeira semana. Recarregue para o anúncio não parar no meio.
        </p>
      )}
      <p className="mt-3 text-[11px] text-muted-foreground">Nos primeiros 7 dias, evite mudar a campanha: a Meta está aprendendo quem compra.</p>
    </section>
  );
}
